var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSprintLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 294.4 121.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffdd05;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "M12.14,96.68c-3.94,0-7.8-.48-10.94-1.29l.49-8.28c3.05,1.12,7.31,2.01,11.25,2.01,5.95,0,10.77-2.49,10.77-8.36,0-11.42-23.72-6.59-23.72-24.13,0-9.33,7.32-15.83,19.94-15.83,3.21,0,6.51.4,9.81.96l-.49,7.8c-3.13-.96-6.59-1.53-9.81-1.53-6.75,0-10.21,3.13-10.21,7.64,0,10.86,23.72,6.84,23.72,23.8,0,9.97-7.88,17.21-20.83,17.21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "M54.11,96.43c-2.25,0-3.94-.08-6.03-.48v17.4h-8.6v-57.44h8.12c0,2.09-.08,5.31-.48,7.48h.16c2.25-5.07,6.83-8.28,12.94-8.28,9.49,0,14.71,6.75,14.71,18.81,0,14.08-7.47,22.51-20.82,22.51M57.97,62.18c-6.43,0-9.89,7.56-9.89,14.38v12.31c1.85.56,3.86.8,6.27.8,6.83,0,11.5-4.18,11.5-14.96,0-8.04-2.49-12.54-7.88-12.54Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "M102.52,63.55c-7.96-1.44-11.82,4.1-11.82,16.09v16.24h-8.61v-39.96h8.21c0,2.25-.25,5.79-.81,8.84h.16c1.77-5.39,5.79-10.38,13.27-9.65l-.4,8.44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path9",
    d: "M114.8,49.96c-3.06,0-5.55-2.41-5.55-5.39s2.49-5.39,5.55-5.39,5.47,2.33,5.47,5.39-2.49,5.39-5.47,5.39M119.06,95.87h-8.6v-39.96h8.6v39.96Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "M154.45,95.87v-25.73c0-4.98-1.37-7.88-5.95-7.88-6.03,0-10.46,6.35-10.46,14.3v19.3h-8.6v-39.96h8.2c0,2.09-.16,5.55-.56,7.8l.08.08c2.33-5.14,7.16-8.68,13.91-8.68,9.08,0,11.9,5.71,11.9,12.79v27.98h-8.52"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "M186.68,96.59c-8.52,0-11.1-3.29-11.1-12.21v-21.79h-7.63v-6.67h7.63v-12.71l8.52-2.33v15.04h10.53v6.67h-10.45v19.14c0,5.95,1.21,7.56,5.22,7.56,1.77,0,3.7-.24,5.23-.64v7.08c-2.33.49-5.31.88-7.96.88"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path15",
    className: "cls-1",
    d: "M233.71,84.8c11.72-15.09,20.94-32.81,20.94-45.54,0-6.65-4.76-11.3-10.98-14.82.12,13.83-4.67,46.26-9.96,60.36"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path17",
    className: "cls-1",
    d: "M195.28,121.97c27.47-9.19,67.29-30.6,94.99-49.72,2.32-1.6,4.14-3.08,4.14-5.68,0-4.52-8.28-10.58-12.29-12.99-21.79,22.65-65.16,56.6-86.83,68.4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path19",
    className: "cls-1",
    d: "M220.76,102.73c16.94-11.71,41.54-33.74,49.87-45.73,1.96-2.82,3.42-4.45,3.42-7.4,0-4.84-5.64-8.38-9.7-10.85-9.73,22.92-31.58,51.47-43.59,63.98"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path21",
    className: "cls-1",
    d: "M236.19,70.25c2.19-14.48.9-31.95-1.89-42.91-1.52-5.97-6.9-12.71-11.88-14.81,6.53,18.52,12.13,44.9,13.77,57.72"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path23",
    className: "cls-1",
    d: "M231.37,49.94c-5.13-13.87-17.92-42.78-36.74-49.94,12.25,13.52,30.42,40.34,36.74,49.94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprintLogo);
export default __webpack_public_path__ + "static/media/sprint-logo.c1c3e0b1f29a239298563284d95c7a36.svg";
export { ForwardRef as ReactComponent };